import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Input } from '../Input/Input';
import { Button } from '../Button/Button';
import { Link } from 'react-router-dom';

const validationSchema = Yup.object({
  email: Yup.string().email('Invalid email format').required('Email is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
});

interface SignInFormProps {
  onSubmit: (values: { email: string; password: string }) => void;
}

export const SignInForm = ({ onSubmit }: SignInFormProps) => {
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit,
  });

  return (
    <form className="form sign-in-form" onSubmit={formik.handleSubmit}>
      <Input
        id="email"
        name="email"
        type="email"
        label="Email"
        placeholder="Enter your email"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        error={formik.errors.email}
        touched={formik.touched.email}
      />

      <div className="form-group">
        <div className="password-header">
          <Link to="/forgot-password" className="forgot-password-link">
            Forgot Password?
          </Link>
          <Input
            id="password"
            name="password"
            type="password"
            label="Password"
            placeholder="Enter password"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.password}
            error={formik.errors.password}
            touched={formik.touched.password}
          />
        </div>
      </div>

      <Button type="submit">Sign In</Button>
    </form>
  );
};
